export default __webpack_public_path__ + "static/media/pastel-outfit-model.962ac103.jpg";